import React, { useState, useEffect } from 'react';
import { View, TextInput, Pressable, FlatList, ActivityIndicator } from 'react-native';
import { Feather, FontAwesome } from '@expo/vector-icons';
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { auth, firestore } from '../../services/firebase';
import {
  collection,
  addDoc,
  doc,
  getDocs,
  deleteDoc,
} from 'firebase/firestore';
import { ContainerMobile, ContainerDesktop, Content } from './style';
import { StandardText, FooterText } from '../../config/theme/globalStyles';
import THEME from '../../config/theme';
import useViewport from '../../hooks/useViewport';
import { useCustomTheme } from '../../contexts/useCustomTheme';
import CommentItem from './CommentItem';

const VideoComments = ({ login, comments, videoId, categoryId, cardId }) => {
  const { width } = useViewport();
  const breakpoint = 1080;
  const Container = width < breakpoint ? ContainerMobile : ContainerDesktop;
  const { customColor, customFont } = useCustomTheme();

  const [user, setUser] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [newComment, setNewComment] = useState('');
  const [newReply, setNewReply] = useState('');
  const [isReply, setIsReply] = useState(false);
  const [commentId, setCommentId] = useState('');

  const [commentPlaceholder, setCommentPlaceholder] = useState('Faça um comentário');

  const changeCommentPlaceholder = (text, value) => {
    setCommentPlaceholder(text);
    setIsReply(true);
    setCommentId(value);
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user && !user.isAnonymous) {
        setUser(user);
      } else if (!user) {
        signInAnonymously(auth).catch((error) => console.error(error));
      }
    });
  }, []);

  useEffect(() => {
    if (comments === undefined) return;

    const delay = setTimeout(() => {
      setIsLoading(false);
    }, 500); // ou 150ms para dar tempo de exibir o loader

    return () => clearTimeout(delay);
  }, [comments]);


  const sendComment = async () => {
    if (!user) return;
    let date = new Date();

    await addDoc(
      collection(
        firestore,
        'categories',
        categoryId,
        'cards',
        cardId,
        'videos',
        videoId,
        'comments'
      ),
      {
        comment: newComment,
        userId: user.uid,
        createdAt: date,
      }
    );
    setNewComment('');
  };

  const sendReply = async (commentId) => {
    if (!user) return;
    const date = new Date();

    await addDoc(
      collection(
        firestore,
        'categories',
        categoryId,
        'cards',
        cardId,
        'videos',
        videoId,
        'comments',
        commentId,
        'replies'
      ),
      {
        comment: newReply,
        userId: user.uid,
        createdAt: date,
      }
    );
    setNewReply('');
  };

  // const ItemSeparatorView = () => {
  //   return (
  //     <View
  //       style={{
  //         height: 0.5,
  //         width: '100%',
  //         backgroundColor:
  //           customColor && customColor.text && customColor.text.app
  //             ? customColor.text.app
  //             : THEME.COLORS.TEXT_MAIN,
  //       }}
  //     />
  //   );
  // };

  const handleDeleteComment = async (commentId) => {
    const commentRef = doc(
      firestore,
      'categories',
      categoryId,
      'cards',
      cardId,
      'videos',
      videoId,
      'comments',
      commentId
    );

    const repliesSnapshot = await getDocs(collection(commentRef, 'replies'));
    const deleteRepliesPromises = repliesSnapshot.docs.map((replyDoc) =>
      deleteDoc(replyDoc.ref)
    );
    await Promise.all(deleteRepliesPromises);
    await deleteDoc(commentRef);
  };

  const handleDeleteReplyCard = async (commentId, replyId) => {
    const replyRef = doc(
      firestore,
      'categories',
      categoryId,
      'cards',
      cardId,
      'videos',
      videoId,
      'comments',
      commentId,
      'replies',
      replyId
    );

    await deleteDoc(replyRef);
  };

  const isAdminOrIsUserCurrent = (user, isAdmin, id) => {
    return user?.uid === id || isAdmin === true;
  };

  return (
    <Container>
      <StandardText
        color={customColor?.text?.app || THEME.COLORS.TEXT_MAIN}
        style={{
          fontFamily: customFont?.fontFamilySubtitle || THEME.FONTFAMILY.MEDIUM,
          fontSize: customFont?.fontSM || THEME.FONTSIZE.SMALL,
        }}
        textAlign="left"
      >
        Comentários
      </StandardText>

      {/* {isLoading ? (
        <ActivityIndicator
          style={{
            flex: 1,
            justifyContent: 'center',
            alignSelf: 'center',
          }}
          color={customColor?.primary || THEME.COLORS.PRIMARY_800}
        />
      )
       : comments?.length === 0 ? (
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <FooterText
            color={customColor?.text?.app || THEME.COLORS.TEXT_MAIN}
            style={{
              fontFamily: customFont?.fontFamilyText || THEME.FONTFAMILY.LIGHT,
              fontSize: customFont?.fontXS || THEME.FONTSIZE.EXTRASMALL,
            }}
          >
            Não há comentários
          </FooterText>
        </View>
      ) 
      : (
        <FlatList
          data={comments}
          // ItemSeparatorComponent={ItemSeparatorView}
          renderItem={({ item }) => (
            <CommentItem
              handleDeleteComment={handleDeleteComment}
              login={login}
              comment={item}
              editPlaceholder={changeCommentPlaceholder}
              setIsLoading={() => setIsLoading(false)}
              isAdminOrIsUserCurrent={isAdminOrIsUserCurrent}
              userId={user}
              handleDeleteReplyCard={handleDeleteReplyCard}
            />
          )}
        />
      )} */}

      <FlatList
        data={comments}
        // ItemSeparatorComponent={ItemSeparatorView}
        renderItem={({ item }) => (
          <CommentItem
            handleDeleteComment={handleDeleteComment}
            login={login}
            comment={item}
            editPlaceholder={changeCommentPlaceholder}
            setIsLoading={() => setIsLoading(false)}
            isAdminOrIsUserCurrent={isAdminOrIsUserCurrent}
            userId={user}
            handleDeleteReplyCard={handleDeleteReplyCard}
          />
        )}
      />

      {/* INPUT DE COMENTÁRIO/RESPOSTA */}
      <Content>
        {!isReply && user ? (
          <>
            <Feather name="user" size={22} color={customColor?.text?.app || THEME.COLORS.TEXT_MAIN} />
            <TextInput
              placeholder={commentPlaceholder}
              value={newComment}
              onChangeText={setNewComment}
              placeholderTextColor="#7F7F7F"
              style={{
                backgroundColor: '#DBDBDB',
                color: '#7F7F7F',
                padding: 10,
                flex: 1,
                margin: 10,
                borderRadius: 5,
                fontFamily: customFont?.fontFamilyText || THEME.FONTFAMILY.MEDIUM,
              }}
            />
            <Pressable onPress={sendComment}>
              <FontAwesome
                name="send-o"
                size={18}
                color="white"
                style={{
                  backgroundColor: customColor?.primary || THEME.COLORS.PRIMARY_900,
                  padding: '0.4rem',
                  borderRadius: '5px',
                }}
              />
            </Pressable>
          </>
        ) : (
          isReply &&
          user && (
            <>
              <Feather name="user" size={22} color={customColor?.text?.app || THEME.COLORS.TEXT_MAIN} />
              <TextInput
                placeholder={commentPlaceholder}
                value={newReply}
                onChangeText={setNewReply}
                placeholderTextColor="#7F7F7F"
                style={{
                  backgroundColor: '#DBDBDB',
                  color: '#7F7F7F',
                  padding: 10,
                  flex: 1,
                  margin: 10,
                  borderRadius: 5,
                  fontFamily: customFont?.fontFamilyText || THEME.FONTFAMILY.MEDIUM,
                }}
              />
              <Pressable onPress={() => sendReply(commentId)}>
                <FontAwesome
                  name="send-o"
                  size={22}
                  color="white"
                  style={{
                    backgroundColor: customColor?.primary || THEME.COLORS.PRIMARY_900,
                    padding: '0.4rem',
                    borderRadius: '5px',
                  }}
                />
              </Pressable>
            </>
          )
        )}
      </Content>
    </Container>
  );
};

export default VideoComments;
